import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import useCreateBankAccount from '@/features/dashboard/paymentConfig/hooks/useCreateBankAccount.ts';
import {
  createBankAccountSchema,
  CreateBankAccountFormData,
  CreateBankAccountInputData,
  createBankAccountDefaultValues,
} from '@/features/dashboard/paymentConfig/schemas/bankAccountSchema.ts';
import BankAccountForm from '@/features/dashboard/paymentConfig/components/BankAccountForm.tsx';

const CreateBankAccountModal = ({ onClose }: { onClose: () => void }) => {
  const createMutation = useCreateBankAccount();

  const methods = useForm<CreateBankAccountInputData>({
    resolver: zodResolver(createBankAccountSchema),
    defaultValues: createBankAccountDefaultValues,
  });

  const { handleSubmit } = methods;

  const onSubmit = (data: CreateBankAccountFormData) => {
    createMutation.mutate(data, { onSuccess: () => onClose() });
  };

  return (
    <Modal
      onClose={onClose}
      isDirty={methods.formState.isDirty}
      className="max-w-[620px]"
    >
      <FormProvider {...methods}>
        <form
          onSubmit={(e) => {
            e.stopPropagation();
            handleSubmit(onSubmit)(e);
          }}
        >
          <ModalHeader title="Dodaj konto bankowe" onClose={onClose} />
          <ModalContent>
            <BankAccountForm />
          </ModalContent>
          <ModalFooter>
            <ActionButton
              tone="ghost"
              size="sm"
              type="button"
              onClick={onClose}
            >
              Anuluj
            </ActionButton>
            <ActionButton
              tone="accent"
              size="sm"
              type="submit"
              isLoading={createMutation.isPending}
            >
              Dodaj
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default CreateBankAccountModal;
